module.exports = __webpack_public_path__ + "img/produtividade-selecionado.16b98a23.svg";